// ========== Business Profile ==========
export const BUSINESS_PROFILE_PERMISSIONS = {
  VIEW: 'KHDN.ThongTinDoanhNghiep',
  VIEW_DETAIL: 'KHDN.ThongTinDoanhNghiep.XemChiTiet',
};

// ========== User Profile ==========
export const USER_PROFILE_PERMISSIONS = {
  BASE: 'KHDN.HoSoNguoiSuDung',
  SINGLE: 'KHDN.HoSoNguoiSuDung.DonLe',
  VIEW_LIST: 'KHDN.HoSoNguoiSuDung.XemDanhSach',
  VIEW_DETAIL: 'KHDN.HoSoNguoiSuDung.XemChiTiet',
  VIEW_HISTORY: 'KHDN.HoSoNguoiSuDung.XemLichSu',
  CREATE: 'KHDN.HoSoNguoiSuDung.TaoMoi',
  UPDATE: 'KHDN.HoSoNguoiSuDung.CapNhat',
  UPDATE_STATUS: 'KHDN.HoSoNguoiSuDung.CapNhatTrangThai',
  APPROVE: 'KHDN.HoSoNguoiSuDung.Duyet',
  EXPORT: 'KHDN.HoSoNguoiSuDung.Export',
  DELETE_BATCH: 'KHDN.HoSoNguoiSuDung.XoaLo',
  DELETE_SINGLE: 'KHDN.HoSoNguoiSuDung.XoaDonLe',
  APPROVE_BATCH: 'KHDN.HoSoNguoiSuDung.DuyetLo',
  BATCH: 'KHDN.HoSoNguoiSuDung.Lo',
  BATCH_VIEW_LIST: 'KHDN.HoSoNguoiSuDung.Lo.XemDanhSach',
  BATCH_VIEW_DETAIL: 'KHDN.HoSoNguoiSuDung.Lo.XemChiTiet',
  BATCH_IMPORT_EXCEL: 'KHDN.HoSoNguoiSuDung.Lo.ImportExcel',
  BATCH_EXPORT_TEMPLATE: 'KHDN.HoSoNguoiSuDung.Lo.ExportTemplate',
  BATCH_EXPORT: 'KHDN.HoSoNguoiSuDung.Lo.Export',
};

// ========== Localpay ==========
export const LOCALPAY_PERMISSIONS = {
  BASE: 'KHDN.Localpay',
  VIEW_LIST: 'KHDN.Localpay.XemDanhSach',
  VIEW_BALANCE: 'KHDN.Localpay.XemSoDu',
  EXPORT: 'KHDN.Localpay.Export',
};

// ========== Change SIM ==========
export const CHANGE_SIM_PERMISSIONS = {
  BASE: 'KHDN.DoiSim',
  VIEW_LIST: 'KHDN.DoiSim.XemDanhSach',
  VIEW_DETAIL: 'KHDN.DoiSim.XemChiTiet',
  CREATE: 'KHDN.DoiSim.TaoMoi',
  UPDATE: 'KHDN.DoiSim.CapNhat',
  DELETE: 'KHDN.DoiSim.Xoa',
  CANCEL: 'KHDN.DoiSim.Huy',
  TRANSFER_SIM: 'KHDN.DoiSim.ChuyenSIM',
  CHECK_ESIM_EXPIRED: 'KHDN.DoiSim.KiemTraHetHanESIM',
  RETRY: 'KHDN.DoiSim.Retry',
  PAYMENT: 'KHDN.DoiSim.ThanhToan',
  EXPORT_TEMPLATE: 'KHDN.DoiSim.ExportTemplate',
  IMPORT_EXCEL: 'KHDN.DoiSim.ImportExcel',
  EXPORT_IMPORT_LIST: 'KHDN.DoiSim.DanhsachImport.Export',
  EXPORT_LIST: 'KHDN.DoiSim.DanhSachDoiSim.Export',
};

// ========== Connection ==========
export const CONNECTION_PERMISSIONS = {
  BASE: 'KHDN.DauNoi',
  SINGLE: 'KHDN.DauNoi.DauNoiDonLe',
  SINGLE_CHECK_SERIAL: 'KHDN.DauNoi.DauNoiDonLe.CheckSerial',
  SINGLE_RESERVE_NUMBER: 'KHDN.DauNoi.DauNoiDonLe.GiuSo',
  SINGLE_PERSONAL_CHECK_STATUS: 'KHDN.DauNoi.DauNoiDonLe.CaNhan.KiemTraTrangThaiSerial',
  SINGLE_PERSONAL_CONNECT: 'KHDN.DauNoi.DauNoiDonLe.CaNhan.DauNoi',
  SINGLE_BUSINESS_CONNECT: 'KHDN.DauNoi.DauNoiDonLe.DoanhNghiep.DauNoi',
  SINGLE_PERSONAL_RESELECT_NUMBER: 'KHDN.DauNoi.DauNoiDonLe.CaNhan.ChonLaiSo',
  SINGLE_PERSONAL_RETRY: 'KHDN.DauNoi.DauNoiDonLe.CaNhan.Retry',
  SINGLE_BUSINESS_RETRY: 'KHDN.DauNoi.DauNoiDonLe.DoanhNghiep.Retry',
  BATCH: 'KHDN.DauNoi.DauNoiTheoLo',
  BATCH_VIEW_LIST: 'KHDN.DauNoi.DauNoiTheoLo.XemDanhSach',
  BATCH_VIEW_DETAIL: 'KHDN.DauNoi.DauNoiTheoLo.XemChiTiet',
  BATCH_PERSONAL_CREATE: 'KHDN.DauNoi.DauNoiTheoLo.CaNhan.TaoMoi',
  BATCH_BUSINESS_CREATE: 'KHDN.DauNoi.DauNoiTheoLo.DoanhNghiep.TaoMoi',
  BATCH_PERSONAL_CHECK_SERIALS: 'KHDN.DauNoi.DauNoiTheoLo.CaNhan.CheckSerials',
  BATCH_BUSINESS_CHECK_SERIALS: 'KHDN.DauNoi.DauNoiTheoLo.DoanhNghiep.CheckSerials',
  BATCH_PERSONAL_UPDATE: 'KHDN.DauNoi.DauNoiTheoLo.CaNhan.CapNhat',
  BATCH_BUSINESS_UPDATE: 'KHDN.DauNoi.DauNoiTheoLo.DoanhNghiep.CapNhat',
  BATCH_PERSONAL_CONNECT: 'KHDN.DauNoi.DauNoiTheoLo.CaNhan.DauNoi',
  BATCH_BUSINESS_CONNECT: 'KHDN.DauNoi.DauNoiTheoLo.DoanhNghiep.DauNoi',
  BATCH_RETRY: 'KHDN.DauNoi.DauNoiTheoLo.Retry',
  BATCH_DELETE: 'KHDN.DauNoi.DauNoiTheoLo.XoaDon',
  BATCH_IMPORT_EXCEL: 'KHDN.DauNoi.DauNoiTheoLo.ImportExcel',
  BATCH_EXPORT: 'KHDN.DauNoi.DauNoiTheoLo.Export',
  BATCH_EXPORT_TEMPLATE: 'KHDN.DauNoi.DauNoiTheoLo.ExportTemplate',
  HISTORY: 'KHDN.DauNoi.LichSu',
  HISTORY_VIEW_LIST: 'KHDN.DauNoi.LichSu.XemDanhSach',
  HISTORY_VIEW_DETAIL: 'KHDN.DauNoi.LichSu.XemChiTiet',
  HISTORY_EXPORT: 'KHDN.DauNoi.LichSu.Export',
  CCQ_REQUEST: 'KHDN.DauNoi.YeuCauCCQ',
};

// ========== Assign Package ==========
export const ASSIGN_PACKAGE_PERMISSIONS = {
  BASE: 'KHDN.GanGoi',
  LIST: 'KHDN.GanGoi.DanhSach',
  VIEW: 'KHDN.GanGoi.DanhSach.Xem',
  VIEW_DETAIL: 'KHDN.GanGoi.DanhSach.XemChiTiet',
  CREATE: 'KHDN.GanGoi.DanhSach.TaoMoi',
  UPDATE: 'KHDN.GanGoi.DanhSach.CapNhat',
  ASSIGN: 'KHDN.GanGoi.DanhSach.GanGoi',
  RETRY: 'KHDN.GanGoi.DanhSach.Retry',
  DELETE: 'KHDN.GanGoi.DanhSach.XoaDon',
  CHECK_SERIALS: 'KHDN.GanGoi.DanhSach.CheckSerials',
  CANCEL: 'KHDN.GanGoi.DanhSach.Huy',
  CHECK_ESIM: 'KHDN.GanGoi.DanhSach.CheckESIM',
  PAYMENT: 'KHDN.GanGoi.DanhSach.ThanhToan',
  EXPORT: 'KHDN.GanGoi.DanhSach.Export',
  EXPORT_TEMPLATE: 'KHDN.GanGoi.DanhSach.ExportTemplate',
  IMPORT_EXCEL: 'KHDN.GanGoi.DanhSach.ImportExcel',
  HISTORY: 'KHDN.GanGoi.LichSu',
  HISTORY_VIEW_LIST: 'KHDN.GanGoi.LichSu.XemDanhSach',
  HISTORY_VIEW_DETAIL: 'KHDN.GanGoi.LichSu.XemChiTiet',
  HISTORY_EXPORT: 'KHDN.GanGoi.LichSu.Export',
};

// ========== Subscriber ==========
export const SUBSCRIBER_PERMISSIONS = {
  BASE: 'KHDN.ThueBao',
  LIST: 'KHDN.ThueBao.DanhSach',
  VIEW: 'KHDN.ThueBao.DanhSach.Xem',
  VIEW_DETAIL: 'KHDN.ThueBao.DanhSach.ChiTiet',
  VIEW_HISTORY: 'KHDN.ThueBao.DanhSach.LichSu',
  VIEW_HISTORY_DETAIL: 'KHDN.ThueBao.DanhSach.ChiTietLichSu',
  EXPORT: 'KHDN.ThueBao.DanhSach.Export',
  SEARCH: 'KHDN.ThueBao.TraCuu',
  SEARCH_LIST: 'KHDN.ThueBao.TraCuu.DanhSach',
  SEARCH_DETAIL: 'KHDN.ThueBao.TraCuu.ChiTiet',
  VIEW_SUBSCRIBER_HISTORY: 'KHDN.ThueBao.XemLichSuThueBao',
};

// ========== ESIM ==========
export const ESIM_PERMISSIONS = {
  BASE: 'KHDN.ESIM',
  VIEW_LIST: 'KHDN.ESIM.DanhSach',
  EXPORT: 'KHDN.ESIM.Export',
};

// ========== Package Management (Register/Cancel/Load) ==========
export const PACKAGE_MANAGEMENT_PERMISSIONS = {
  BASE: 'KHDN.DangKyHuyGoi',
  // Register Package
  REGISTER_LIST: 'KHDN.DangKyHuyGoi.DangKy.DanhSach',
  REGISTER_VIEW: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Xem',
  REGISTER_VIEW_DETAIL: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.ChiTiet',
  REGISTER_IMPORT: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Import',
  REGISTER_CREATE: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Tao',
  REGISTER_UPDATE: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.CapNhat',
  REGISTER_PACKAGE: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.DangKyGoi',
  REGISTER_DELETE: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Xoa',
  REGISTER_CANCEL: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Huy',
  REGISTER_PAYMENT: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.ThanhToan',
  REGISTER_EXPORT_SUCCESS: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.ExportTemplateThanhCong',
  REGISTER_EXPORT_FAILED: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.ExportTemplateThatBai',
  REGISTER_EXPORT: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.Export',
  REGISTER_EXPORT_TEMPLATE: 'KHDN.DangKyHuyGoi.DangKy.DanhSach.ExportTemplate',
  LOAD_DATA_IMPORT: 'KHDN.DangKyHuyGoi.NapData.DanhSach.Import',
  // Load Data
  LOAD_DATA: 'KHDN.NapDangKiHuyGoi.NapData',
  LOAD_DATA_PACKAGE_LIST: 'KHDN.NapDangKiHuyGoi.NapData.DanhSachGoiData',
  LOAD_DATA_PAYMENT_METHOD: 'KHDN.NapDangKiHuyGoi.NapData.DanhSachPhuongThucThanhToan',
  LOAD_DATA_ORDER_LIST: 'KHDN.NapDangKiHuyGoi.NapData.DanhSachDonHangNapData',
  LOAD_DATA_EXPORT: 'KHDN.NapDangKiHuyGoi.NapData.Export',
  LOAD_DATA_VIEW_DETAIL: 'KHDN.NapDangKiHuyGoi.NapData.ChiTietDonHang',
  LOAD_DATA_CHECK_PAYMENT_METHOD: 'KHDN.NapDangKiHuyGoi.NapData.KiemTraPhuongThucThanhToan',
  LOAD_DATA_CREATE_ORDER: 'KHDN.NapDangKiHuyGoi.NapData.TaoDonHangNapData',
  LOAD_DATA_CHECK_SUBSCRIBER: 'KHDN.NapDangKiHuyGoi.NapData.KiemTraSothuebao',
  LOAD_DATA_PAYMENT_ORDER: 'KHDN.NapDangKiHuyGoi.NapData.ThanhToan',
  LOAD_DATA_CREATE_PAYMENT: 'KHDN.NapDangKiHuyGoi.NapData.TienHanhThanhToan',
  LOAD_DATA_CANCEL: 'KHDN.NapDangKiHuyGoi.NapData.Huy',
  LOAD_DATA_PAYMENT_DATA: 'KHDN.NapDangKiHuyGoi.NapData.NapData',
  LOAD_DATA_DELETE: 'KHDN.NapDangKiHuyGoi.NapData.XoaDonHang',
  LOAD_DATA_EXPORT_TEMPLATE: 'KHDN.NapDangKiHuyGoi.NapData.ExportTemplate',
  LOAD_DATA_EXPORT_DETAILS: 'KHDN.NapDangKiHuyGoi.NapData.ExportChiTietDonHang',
  // Cancel Package
  CANCEL_LIST: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach',
  CANCEL_VIEW: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Xem',
  CANCEL_VIEW_DETAIL: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.ChiTiet',
  CANCEL_IMPORT: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Import',
  CANCEL_CREATE: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Tao',
  CANCEL_UPDATE: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.CapNhat',
  CANCEL_PACKAGE: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Huy',
  CANCEL_RETRY: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Huy.Retry',
  CANCEL_DELETE: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Xoa',
  CANCEL_EXPORT: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Export',
  CANCEL_EXPORT_TEMPLATE: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.ExportTemplate',
  CANCEL_EXPORT_IMPORT_RESULT: 'KHDN.DangKyHuyGoi.HuyGoi.DanhSach.Export.Result.Import',
  // History
  HISTORY: 'KHDN.DangKyHuyGoi.LichSu',
  HISTORY_VIEW_LIST: 'KHDN.DangKyHuyGoi.LichSu.XemDanhSach',
  HISTORY_EXPORT: 'KHDN.DangKyHuyGoi.LichSu.Export',
};

// ========== Top-up ==========
export const TOPUP_PERMISSIONS = {
  BASE: 'KHDN.NapTien',
  LIST: 'KHDN.NapTien.DanhSach',
  VIEW: 'KHDN.NapTien.DanhSach.Xem',
  VIEW_DETAIL: 'KHDN.NapTien.DanhSach.ChiTiet',
  IMPORT: 'KHDN.NapTien.DanhSach.Import',
  CREATE: 'KHDN.NapTien.DanhSach.Tao',
  UPDATE: 'KHDN.NapTien.DanhSach.CapNhat',
  EXPORT: 'KHDN.NapTien.DanhSach.Export',
  DELETE: 'KHDN.NapTien.DanhSach.Xoa',
  CANCEL: 'KHDN.NapTien.DanhSach.Huy',
  PAYMENT: 'KHDN.NapTien.DanhSach.ThanhToan',
  TOPUP_CHECK_STB: 'KHDN.NapTien.DanhSach.KiemTraSTB',
  EXPORT_SUCCESS_FAILED: 'KHDN.NapTien.DanhSach.ExportThanhCongThatBai',
  HISTORY: 'KHDN.NapTien.LichSu',
  HISTORY_VIEW_LIST: 'KHDN.NapTien.LichSu.XemDanhSach',
  HISTORY_EXPORT: 'KHDN.NapTien.LichSu.Export',
};

// ========== Report ==========
export const REPORT_PERMISSIONS = {
  BASE: 'KHDN.BaoCao',
  DATA_USAGE: 'KHDN.BaoCao.LuuLuongData',
  DATA_USAGE_VIEW: 'KHDN.BaoCao.LuuLuongData.Xem',
  DATA_USAGE_EXPORT: 'KHDN.BaoCao.LuuLuongData.Export',
};

// ========== Transaction ==========
export const TRANSACTION_PERMISSIONS = {
  BASE: 'KHDN.GiaoDich',
  VIEW_LIST: 'KHDN.GiaoDich.XemDanhSach',
  EXPORT: 'KHDN.GiaoDich.Export',
};

// ========== Data Account Management ==========
export const DATA_ACCOUNT_PERMISSIONS = {
  BASE: 'KHDN.QuanLyTaiKhoanData',
  VIEW_ORDER_LIST: 'KHDN.QuanLyTaiKhoanData.DanhSachDonHang',
  VIEW_ORDER_DETAIL: 'KHDN.QuanLyTaiKhoanData.ChiTietDonHang',
  EXPORT: 'KHDN.QuanLyTaiKhoanData.Export',
};

// ========== File Management ==========
export const FILE_MANAGEMENT_PERMISSIONS = {
  BASE: 'KHDN.QuanLyFile',
  VIEW_LIST: 'KHDN.QuanLyFile.XemDanhSach',
  CREATE: 'KHDN.QuanLyFile.TaoMoi',
};

// ========== CCQ Request ==========
export const CCQ_REQUEST_PERMISSIONS = {
  BASE: 'KHDN.YeuCauCCQ',
  REQUEST: 'KHDN.YeuCauCCQ.YeuCau',
  VIEW_LIST: 'KHDN.YeuCauCCQ.YeuCau.XemDanhSach',
  VIEW_DETAIL: 'KHDN.YeuCauCCQ.YeuCau.XemChiTiet',
  IMPORT_EXCEL: 'KHDN.YeuCauCCQ.YeuCau.ImportFileExcel',
  CREATE: 'KHDN.YeuCauCCQ.YeuCau.TaoYeuCau',
  UPDATE: 'KHDN.YeuCauCCQ.YeuCau.CapNhatYeuCau',
  CONFIRM: 'KHDN.YeuCauCCQ.YeuCau.XacNhanYeuCau',
  CANCEL: 'KHDN.YeuCauCCQ.YeuCau.HuyYeuCau',
  DELETE: 'KHDN.YeuCauCCQ.YeuCau.XoaYeuCau',
  RETRY: 'KHDN.YeuCauCCQ.YeuCau.Retry',
  EXPORT_RESULT: 'KHDN.YeuCauCCQ.YeuCau.ExportDanhSachDungSai',
  EXPORT_REQUEST_LIST: 'KHDN.YeuCauCCQ.YeuCau.ExportDanhYeuCau',
  EXPORT_TEMPLATE: 'KHDN.YeuCauCCQ.YeuCau.ExportTemplate',
  HISTORY: 'KHDN.YeuCauCCQ.LichSu',
  HISTORY_VIEW: 'KHDN.YeuCauCCQ.LichSuCCQ.XemLichSu',
  HISTORY_EXPORT: 'KHDN.YeuCauCCQ.LichSuCCQ.ExportLichSu',
};

// ========== Combined Permissions Export ==========
export const PERMISSIONS = {
  BUSINESS_PROFILE: BUSINESS_PROFILE_PERMISSIONS,
  USER_PROFILE: USER_PROFILE_PERMISSIONS,
  LOCALPAY: LOCALPAY_PERMISSIONS,
  CHANGE_SIM: CHANGE_SIM_PERMISSIONS,
  CONNECTION: CONNECTION_PERMISSIONS,
  ASSIGN_PACKAGE: ASSIGN_PACKAGE_PERMISSIONS,
  SUBSCRIBER: SUBSCRIBER_PERMISSIONS,
  ESIM: ESIM_PERMISSIONS,
  PACKAGE_MANAGEMENT: PACKAGE_MANAGEMENT_PERMISSIONS,
  TOPUP: TOPUP_PERMISSIONS,
  REPORT: REPORT_PERMISSIONS,
  TRANSACTION: TRANSACTION_PERMISSIONS,
  DATA_ACCOUNT: DATA_ACCOUNT_PERMISSIONS,
  FILE_MANAGEMENT: FILE_MANAGEMENT_PERMISSIONS,
  CCQ_REQUEST: CCQ_REQUEST_PERMISSIONS,
};
